import React from "react";
import BaseButton from "@components/library/UI/BaseButton";
import "./CardButton.sass";

const CardButton = ({
  children,
  icon = null,
  variant = "primary",
  disabled,
  className = "",
  ...props
}) => {
  const variantClass = disabled
    ? "card-button--disabled"
    : `card-button--${variant}`;
  const classes = `card-button ${variantClass} ${className}`.trim();

  return (
    <BaseButton className={classes} disabled={disabled} {...props}>
      <span className="card-button__content">
        <span className="card-button__text whitespace-nowrap">
          {children}
        </span>

        {icon && (
          <span className="card-button__icon" aria-hidden="true">
            {icon}
          </span>
        )}
      </span>
    </BaseButton>
  );
};

export default CardButton;